import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { MbsValidators } from 'mbs-ui-kit';

export function confirmPasswordValidator(passwordField: string, confirmPasswordField: string): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const password = group.get(passwordField);
    const confirmPassword = group.get(confirmPasswordField);

    if (!password || !confirmPassword) {
      if (!password) {
        console.warn(MbsValidators.validatorMessages.notExistField(passwordField));
      }

      if (!confirmPassword) {
        console.warn(MbsValidators.validatorMessages.notExistField(confirmPasswordField));
      }

      return null;
    }

    if (password.disabled && confirmPassword.disabled) {
      confirmPassword.setErrors(null);

      return null;
    }

    if (confirmPassword.errors && !confirmPassword.errors.notMatch) {
      return null;
    }

    password.setErrors(getPasswordErrors(password));
    confirmPassword.setErrors(getConfirmPasswordErrors(password, confirmPassword));

    return null;
  };
}

function getPasswordErrors(password: AbstractControl): ValidationErrors | null {
  const errorsClone = { ...password.errors };

  if (password.touched && !password.value) {
    return {
      ...errorsClone,
      isEmpty: { message: MbsValidators.validatorMessages.passwordIsEmpty() }
    };
  }

  if (errorsClone?.isEmpty) {
    delete errorsClone.isEmpty;
  }

  return Object.keys(errorsClone || {}).length ? errorsClone : null;
}

function getConfirmPasswordErrors(password: AbstractControl, confirmPassword: AbstractControl): ValidationErrors {
  const errorsClone = { ...confirmPassword.errors };

  if (confirmPassword.touched && !confirmPassword.value) {
    return {
      ...errorsClone,
      isEmpty: { message: MbsValidators.validatorMessages.confirmPasswordIsEmpty() }
    };
  }

  if (confirmPassword.touched && password.value !== confirmPassword.value) {
    return {
      ...errorsClone,
      notMatch: { message: MbsValidators.validatorMessages.passwordsNotMatch() }
    };
  }

  if (errorsClone?.isEmpty) {
    delete errorsClone.isEmpty;
  }

  if (errorsClone?.notMatch) {
    delete errorsClone.notMatch;
  }

  return Object.keys(errorsClone || {}).length ? errorsClone : null;
}
